export default [
  {
    id: 'd400cf00-91de-048c-0772-3a1b13b65a56', // id 全局唯一，终身制
    name: 'sceneManagement',
    path: '/scene-management',
    meta: {
      title: '场景管理',
    },
    // layout: 'default',
    // 根菜单不需要定义 component，由主框架定义
    children: [
      {
        id: '44111c65-9bc6-a1b3-8f30-8a4871a4ca26',
        name: 'sceneManagement',
        path: 'scene-management',
        component: () => {
          return import('./views/SceneManagement')
        },
        meta: {
          title: '场景管理',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            check: {
              id: 1,
              name: 'check',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
      {
        id: '9c7ccc3e-a8c8-4abd-85c2-fba1cb9f7325',
        name: 'sceneManagementVulkan',
        path: 'scene-management-vulkan',
        component: () => {
          return import('./views/SceneManagementVulkan')
        },
        meta: {
          title: '场景管理5.0',
          operations: {
            create: {
              id: 0,
              name: 'create',
              desc: '新增',
              access: true,
            },
            check: {
              id: 1,
              name: 'check',
              desc: '详情',
              access: true,
              group: 'read',
            },
            update: {
              id: 2,
              name: 'update',
              desc: '编辑',
              access: true,
            },
            delete: {
              id: 3,
              name: 'delete',
              desc: '删除',
              access: true,
            },
          },
        },
      },
    ],
  },
]
